// THE one place a human prompt gets its id. Every frame that can wake an agent is stamped here in
// SlackClient.send, so a new send path gets the id for free (composer, session reply, setup cards,
// send_agent_prompt, commands, outbox replay). The relay stores it on the DM row (client_msg_id)
// and forwards it as promptId; the daemon names its "did not run" line `sysn_refused_<id>` with it.
// A caller that already minted one (optimistic bubble, outbox retry) keeps it.
const PROMPT_ID_FIELD: Record<string, "clientMsgId" | "promptId"> = {
  "cyborg:dm": "clientMsgId",
  "cyborg:send_agent_prompt": "promptId",
  "cyborg:agent_command": "clientMsgId",
};

export function withPromptId(data: Record<string, unknown>): Record<string, unknown> {
  const field = typeof data.type === "string" ? PROMPT_ID_FIELD[data.type] : undefined;
  if (!field || (typeof data[field] === "string" && data[field] !== "")) return data;
  return { ...data, [field]: globalThis.crypto.randomUUID() };
}
